<template>
	<button class="btn btn-icon" @click="onClick" type="button">
		<i :class="'icon-'+name"></i>
	</button>
</template>

<script>
	export default {
		props: {
			'name': String
		},

		methods: {
			onClick() {
				this.$emit('click');
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/ui/widgets/icon-button.vue